export default __webpack_public_path__ + "static/char-s-20-zh-Hans-1a75ba6a4d62dcf3dfa7ef50e5d7ea17.png";